export default "__VITE_ASSET__B_Z0QB3h__"